import type { telegramConnectInput } from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useConnectTelegram: telegramConnectInput;
}

const TELEGRAM_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("telegram", [
	"useConnectTelegram",
]);

export { TELEGRAM_SERVICE_KEYS };
